import { Box, Container, Heading } from '@hover/blueprint';
import React from 'react';
import ArrowButton from '../../ui/ArrowButton';

const UnlockPerProperty: React.FC = () => (
  <Container
    maxW="8xl"
    px={{ base: 500, tablet: '56px' }}
    centerContent
    mb={{ base: '80px', desktop: '120px' }}
  >
    <Box
      borderRadius="8px"
      shadow="distance300"
      py={{ base: 400, tablet: 800, desktop: 900 }}
      alignItems="center"
      w="100%"
      maxW="1200px"
      flexDir="column"
      px={{ base: 500, tablet: 800, desktop: '86px' }}
      bg="brandNavy.100"
    >
      <Heading
        textAlign="center"
        marginBottom={{ base: 500, desktop: 600 }}
        size={{ base: 500, tablet: 600 }}
      >
        Unlock per property discounts with a membership plan.
      </Heading>
      <ArrowButton
        colorScheme="primary"
        w={{ base: '100%', tablet: '262px' }}
        variant="outline"
        onClick={() => {
          if (typeof document !== 'undefined') {
            const element = document.getElementById(
              'choose-plan-best-fits-your-team',
            );
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
              });
            }
          }
        }}
      >
        See discounts below
      </ArrowButton>
    </Box>
  </Container>
);

export default UnlockPerProperty;
